// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from share.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function ShareIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M15 9a1 1 0 0 1 .993.883L16 10v5a1 1 0 0 1-.883.993L15 16H1a1 1 0 0 1-.993-.883L0 15v-5a1 1 0 0 1 1.993-.117L2 10v4h12v-4a1 1 0 0 1 .883-.993L15 9ZM8.613.21l.094.083 4 4a1 1 0 0 1-1.32 1.497l-.094-.083L9 3.415V11a1 1 0 0 1-1.993.117L7 11V3.415L4.707 5.707a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1-.083-1.32l.083-.094 4-4A1 1 0 0 1 8.51.14l.102.07Z"
      />
    </svg>
  );
}
